export const Obtain_Ukulele_Music_Score = 'guitarScore/Obtain_Ukulele_Music_Score';
